module.exports = __webpack_public_path__ + "img/sample-3.2a76949.webp";